/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * https://github.com/tldraw/tldraw/blob/d683cc09432197e89bddacf2b706b5eaad40e399/packages/tlschema/src/records/SWInstance.ts
 *
 * Changes:
 *  - Commented out everything but a couple methods
 *  - Disables some of the validators
 */ // import { BaseRecord, createRecordType, defineMigrations, RecordId } from '@supersig/store'
// import { JsonObject } from '@supersig/utils'
// import { T } from '@supersig/validate'
// import { Box2dModel, box2dModelValidator } from '../misc/geometry-types'
// import { idValidator } from '../misc/id-validator'
// import { cursorValidator, TLCursor } from '../misc/TLCursor'
// import { opacityValidator, TLOpacityType } from '../misc/TLOpacity'
// import { scribbleValidator, TLScribble } from '../misc/TLScribble'
// import { StyleProp } from '../styles/StyleProp'
// import { pageIdValidator, TLPageId } from './TLPage'
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { box2dModelValidator } from "../misc/geometry-types";
import { idValidator } from "../misc/id-validator";
/** @internal */ export const instanceIdValidator = idValidator("instance");
export function createInstanceRecordType(stylesById) {
    const stylesForNextShapeValidators = {};
    for (const [id, style] of stylesById){
        stylesForNextShapeValidators[id] = T.optional(style);
    }
    const instanceTypeValidator = T.model("instance", T.object({
        typeName: T.literal("instance"),
        id: idValidator("instance"),
        currentPageId: idValidator("page"),
        followingUserId: T.string.nullable(),
        brush: box2dModelValidator.nullable(),
        // opacityForNextShape: opacityValidator,
        opacityForNextShape: T.any,
        stylesForNextShape: T.object(stylesForNextShapeValidators),
        // cursor: cursorValidator,
        cursor: T.any,
        // scribbles: T.arrayOf(scribbleValidator),
        scribbles: T.arrayOf(T.any),
        isFocusMode: T.boolean,
        isDebugMode: T.boolean,
        isToolLocked: T.boolean,
        exportBackground: T.boolean,
        screenBounds: box2dModelValidator,
        zoomBrush: box2dModelValidator.nullable(),
        isPenMode: T.boolean,
        isGridMode: T.boolean,
        chatMessage: T.string,
        isChatting: T.boolean,
        highlightedUserIds: T.arrayOf(T.string),
        canMoveCamera: T.boolean,
        isFocused: T.boolean,
        devicePixelRatio: T.number,
        isCoarsePointer: T.boolean,
        isHoveringCanvas: T.boolean.nullable(),
        openMenus: T.arrayOf(T.string),
        isChangingStyle: T.boolean,
        isReadonly: T.boolean,
        meta: T.jsonValue,
        // What i've added
        selectedMenu: T.string.nullable(),
        isPreviewing: T.boolean,
        popoverMenu: T.any.nullable(),
        propertyEditingModal: T.any.nullable(),
        aiChatTranscript: T.arrayOf(T.any).nullable().optional(),
        aiChatMessages: T.arrayOf(T.any).nullable().optional(),
        // Element menu sibling for positioning new elements
        elementSibling: T.object({
            type: T.literalEnum("before", "inside", "after"),
            id: idValidator("node")
        }).optional(),
        // previewingVariant: T.string.optional(),
        // websocket url, for remote sync
        wsUrl: T.string.optional(),
        // Preview
        preview: T.object({
            device: T.string,
            scale: T.number,
            orientation: T.literalEnum("portrait", "landscape")
        })
    }));
    return createRecordType("instance", {
        migrations: instanceMigrations,
        validator: instanceTypeValidator,
        scope: "session"
    }).withDefaultProperties(()=>({
            followingUserId: null,
            opacityForNextShape: 1,
            stylesForNextShape: {},
            brush: null,
            scribbles: [],
            cursor: {
                type: "default",
                rotation: 0
            },
            isFocusMode: false,
            exportBackground: false,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            isDebugMode: process.env.NODE_ENV === "development",
            isToolLocked: false,
            screenBounds: {
                x: 0,
                y: 0,
                w: 1080,
                h: 720
            },
            zoomBrush: null,
            isGridMode: false,
            isPenMode: false,
            chatMessage: "",
            isChatting: false,
            highlightedUserIds: [],
            canMoveCamera: true,
            isFocused: false,
            devicePixelRatio: typeof window === "undefined" ? 1 : window.devicePixelRatio,
            isCoarsePointer: false,
            isHoveringCanvas: null,
            openMenus: [],
            isChangingStyle: false,
            isReadonly: false,
            wsUrl: undefined,
            // previewingVariant: undefined,
            // What I've added
            selectedMenu: null,
            isPreviewing: false,
            popoverMenu: null,
            propertyEditingModal: null,
            aiChatTranscript: undefined,
            aiChatMessages: undefined,
            elementSibling: undefined,
            preview: {
                device: "phone",
                scale: 0.8,
                orientation: "portrait"
            },
            meta: {}
        }));
}
/** @internal */ export const instanceVersions = {
    AddTransparentExportBgs: 1,
    RemoveDialog: 2,
    AddToolLockMode: 3,
    RemoveExtraPropsForNextShape: 4,
    AddLabelColor: 5,
    AddFollowingUserId: 6,
    RemoveAlignJustify: 7,
    AddZoom: 8,
    AddVerticalAlign: 9,
    AddScribbleDelay: 10,
    RemoveUserId: 11,
    AddIsPenModeAndIsGridMode: 12,
    HoistOpacity: 13,
    AddChat: 14,
    AddHighlightedUserIds: 15,
    ReplacePropsForNextShapeWithStylesForNextShape: 16,
    AddMeta: 17,
    RemoveCursorColor: 18,
    AddLonelyProperties: 19,
    ReadOnlyReadonly: 20,
    AddHoveringCanvas: 21,
    AddScribbles: 22
};
/** @public */ export const instanceMigrations = defineMigrations({
    currentVersion: instanceVersions.AddScribbles,
    migrators: {
        [instanceVersions.AddTransparentExportBgs]: {
            up: (instance)=>{
                return {
                    ...instance,
                    exportBackground: true
                };
            },
            down: ({ exportBackground: _, ...instance })=>{
                return instance;
            }
        },
        [instanceVersions.RemoveDialog]: {
            up: ({ dialog: _, ...instance })=>{
                return instance;
            },
            down: (instance)=>{
                return {
                    ...instance,
                    dialog: null
                };
            }
        },
        [instanceVersions.AddToolLockMode]: {
            up: (instance)=>{
                return {
                    ...instance,
                    isToolLocked: false
                };
            },
            down: ({ isToolLocked: _, ...instance })=>{
                return instance;
            }
        },
        [instanceVersions.RemoveExtraPropsForNextShape]: {
            up: ({ propsForNextShape, ...instance })=>{
                return {
                    ...instance,
                    propsForNextShape: Object.fromEntries(Object.entries(propsForNextShape).filter(([key])=>[
                            "color",
                            "labelColor",
                            "dash",
                            "fill",
                            "size",
                            "font",
                            "align",
                            "verticalAlign",
                            "icon",
                            "geo",
                            "arrowheadStart",
                            "arrowheadEnd",
                            "spline"
                        ].includes(key)))
                };
            },
            down: (instance)=>{
                // we can't restore these, so do nothing :/
                return instance;
            }
        },
        [instanceVersions.AddLabelColor]: {
            up: ({ propsForNextShape, ...instance })=>{
                return {
                    ...instance,
                    propsForNextShape: {
                        ...propsForNextShape,
                        labelColor: "black"
                    }
                };
            },
            down: (instance)=>{
                const { labelColor: _, ...rest } = instance.propsForNextShape;
                return {
                    ...instance,
                    propsForNextShape: {
                        ...rest
                    }
                };
            }
        },
        [instanceVersions.AddFollowingUserId]: {
            up: (instance)=>{
                return {
                    ...instance,
                    followingUserId: null
                };
            },
            down: ({ followingUserId: _, ...instance })=>{
                return instance;
            }
        },
        [instanceVersions.RemoveAlignJustify]: {
            up: (instance)=>{
                let newAlign = instance.propsForNextShape.align;
                if (newAlign === "justify") {
                    newAlign = "start";
                }
                return {
                    ...instance,
                    propsForNextShape: {
                        ...instance.propsForNextShape,
                        align: newAlign
                    }
                };
            },
            down: (instance)=>{
                return {
                    ...instance
                };
            }
        },
        [instanceVersions.AddZoom]: {
            up: (instance)=>{
                return {
                    ...instance,
                    zoomBrush: null
                };
            },
            down: ({ zoomBrush: _, ...instance })=>{
                return instance;
            }
        },
        [instanceVersions.AddVerticalAlign]: {
            up: (instance)=>{
                return {
                    ...instance,
                    propsForNextShape: {
                        ...instance.propsForNextShape,
                        verticalAlign: "middle"
                    }
                };
            },
            down: (instance)=>{
                const { verticalAlign: _, ...propsForNextShape } = instance.propsForNextShape;
                return {
                    ...instance,
                    propsForNextShape
                };
            }
        },
        [instanceVersions.AddScribbleDelay]: {
            up: (instance)=>{
                if (instance.scribble !== null) {
                    return {
                        ...instance,
                        scribble: {
                            ...instance.scribble,
                            delay: 0
                        }
                    };
                }
                return {
                    ...instance
                };
            },
            down: (instance)=>{
                if (instance.scribble !== null) {
                    const { delay: _delay, ...rest } = instance.scribble;
                    return {
                        ...instance,
                        scribble: rest
                    };
                }
                return {
                    ...instance
                };
            }
        },
        [instanceVersions.RemoveUserId]: {
            up: ({ userId: _, ...instance })=>{
                return instance;
            },
            down: (instance)=>{
                return {
                    ...instance,
                    userId: "user:none"
                };
            }
        },
        [instanceVersions.AddIsPenModeAndIsGridMode]: {
            up: (instance)=>{
                return {
                    ...instance,
                    isPenMode: false,
                    isGridMode: false
                };
            },
            down: ({ isPenMode: _, isGridMode: __, ...instance })=>{
                return instance;
            }
        },
        [instanceVersions.HoistOpacity]: {
            up: ({ propsForNextShape: { opacity, ...propsForNextShape }, ...instance })=>{
                return {
                    ...instance,
                    opacityForNextShape: Number(opacity ?? "1"),
                    propsForNextShape
                };
            },
            down: ({ opacityForNextShape: opacity, ...instance })=>{
                return {
                    ...instance,
                    propsForNextShape: {
                        ...instance.propsForNextShape,
                        opacity: opacity < 0.175 ? "0.1" : opacity < 0.375 ? "0.25" : opacity < 0.625 ? "0.5" : opacity < 0.875 ? "0.75" : "1"
                    }
                };
            }
        },
        [instanceVersions.AddChat]: {
            up: (instance)=>{
                return {
                    ...instance,
                    chatMessage: "",
                    isChatting: false
                };
            },
            down: ({ chatMessage: _, isChatting: __, ...instance })=>{
                return instance;
            }
        },
        [instanceVersions.AddHighlightedUserIds]: {
            up: (instance)=>{
                return {
                    ...instance,
                    highlightedUserIds: []
                };
            },
            down: ({ highlightedUserIds: _, ...instance })=>{
                return instance;
            }
        },
        [instanceVersions.ReplacePropsForNextShapeWithStylesForNextShape]: {
            up: ({ propsForNextShape: _, ...instance })=>{
                return {
                    ...instance,
                    stylesForNextShape: {}
                };
            },
            down: ({ stylesForNextShape: _, ...instance })=>{
                return {
                    ...instance,
                    propsForNextShape: {
                        color: "black",
                        labelColor: "black",
                        dash: "draw",
                        fill: "none",
                        size: "m",
                        icon: "file",
                        font: "draw",
                        align: "middle",
                        verticalAlign: "middle",
                        geo: "rectangle",
                        arrowheadStart: "none",
                        arrowheadEnd: "arrow",
                        spline: "line"
                    }
                };
            }
        },
        [instanceVersions.AddMeta]: {
            up: (record)=>{
                return {
                    ...record,
                    meta: {}
                };
            },
            down: ({ meta: _, ...record })=>{
                return {
                    ...record
                };
            }
        },
        [instanceVersions.RemoveCursorColor]: {
            up: (record)=>{
                const { color: _, ...cursor } = record.cursor;
                return {
                    ...record,
                    cursor
                };
            },
            down: (record)=>{
                return {
                    ...record,
                    cursor: {
                        ...record.cursor,
                        color: "black"
                    }
                };
            }
        },
        [instanceVersions.AddLonelyProperties]: {
            up: (record)=>{
                return {
                    ...record,
                    canMoveCamera: true,
                    isFocused: false,
                    devicePixelRatio: 1,
                    isCoarsePointer: false,
                    openMenus: [],
                    isChangingStyle: false,
                    isReadOnly: false
                };
            },
            down: ({ canMoveCamera: _canMoveCamera, isFocused: _isFocused, devicePixelRatio: _devicePixelRatio, isCoarsePointer: _isCoarsePointer, openMenus: _openMenus, isChangingStyle: _isChangingStyle, isReadOnly: _isReadOnly, ...record })=>{
                return {
                    ...record
                };
            }
        },
        [instanceVersions.ReadOnlyReadonly]: {
            up: ({ isReadOnly: _isReadOnly, ...record })=>{
                return {
                    ...record,
                    isReadonly: _isReadOnly
                };
            },
            down: ({ isReadonly: _isReadonly, ...record })=>{
                return {
                    ...record,
                    isReadOnly: _isReadonly
                };
            }
        },
        [instanceVersions.AddHoveringCanvas]: {
            up: (record)=>{
                return {
                    ...record,
                    isHoveringCanvas: null
                };
            },
            down: ({ isHoveringCanvas: _, ...record })=>{
                return {
                    ...record
                };
            }
        },
        [instanceVersions.AddScribbles]: {
            up: ({ scribble: _, ...record })=>{
                return {
                    ...record,
                    scribbles: []
                };
            },
            down: ({ scribbles: _, ...record })=>{
                return {
                    ...record,
                    scribble: null
                };
            }
        }
    }
});
/** @public */ export const SWINSTANCE_ID = "instance:instance";
